<template>
  <div id="plsRotate" :style="{ height: 'realInnerHeight' }">
    <img id="icon" src="../../public/uploads/rotate.png"/>
    <p id="rotateText">turn to float</p>
    <video playsinline autoplay muted loop style="width:60%; height:auto; top:0; bottom: 0; left: 0; right: 0; margin: auto; position:fixed; object-fit: cover">
    <source src="../../public/uploads/rotate_small.mp4" type="video/mp4">
    </video>

      <div id="empty_container">
      <div class="empty_flex">
      </div>
      <div class="empty_flex">
      </div>
      <div class="empty_flex">
      </div>
      </div>

  </div>
</template>

<script>

export default {
  name: 'RotatePls',
  data() {
    return {
      realInnerHeight: null
    }
  },
  methods: {
    onResize() {
      this.realInnerHeight = window.innerHeight;
      window.console.log(this.realInnerHeight);
    }
  },
  created: function() {
    window.addEventListener('resize', this.onResize);
  },
  mounted: function() {
    this.realInnerHeight = window.innerHeight;
    window.console.log(this.realInnerHeight);
  },
  beforeDestroy() {
  // Unregister the event listener before destroying this Vue instance
  window.removeEventListener('resize', this.onResize);
}
}
</script>
<style scoped>

#plsRotate {
  width:100%;
  height:100%;
}

/* p {
  position:fixed;
  width:100vh;
  height:100vw;
  margin-top:50%;
  text-align:center;
  transform: rotate(90deg);
} */

img#icon {
  position:fixed;
  width:35px;
  margin-left:45%;
  margin-top:16%;
  top:0;
  height:auto;
}

#rotateText {
  font-size:20px;
  position:fixed;
  bottom:10%;
  width:100%;
  text-align: center;
}

#empty_container {
  position:fixed;
	width:100%;
  height:100%;
	border: solid 10px transparent;
	box-sizing: border-box;
	top:0;
	bottom: 0;
	left: 0;
	right: 0;
	margin: auto;
	display: flex; 
	flex-direction: column;
	background-color:transparent;
}

.empty_flex {
  width:100%;
  height:33.33%;
	position:relative;
	flex: none;
	border-radius: 25px;
	box-shadow: inset 0 0 10px lightgrey; 
	box-sizing: border-box;
}

</style>